import {writable} from 'svelte/store'
import {socket} from './io'
import {send} from './connection'
import log from './log'
import format from 'xml-formatter'
import {xml2js} from '@netless/xml-js'

let localState = {}
export const state = writable(localState)
export const stateString = writable('')
export const time = writable(null)

socket.on('data', data => {
	if ('<vmix>' === data.substr(0,6))
		return loadState(data)

	if ('ACTS OK ' === data.substr(0, 8)) {
		try {
			handleActs(data)
		} catch (err) {
			log.push('state watcher', 'Failed to parse ACTS event. Refreshing state from XML.')
			refresh()
		}

		return
	}
})

function loadState(data) {
	try {
		localState = extractXml(data)
		state.set(localState)
	} catch(error) {
		log.push('error', 'Failed state update')
		log.push('error', error)
	}

	stateString.set(format(data))
	time.set((new Date).toTimeString().substr(0,8))
}

function handleActs(data) {
	data = data.split(" ")

	if ('OK' !== data[1] || !data[2])
		return

	if ('Overlay' === data[2]?.substr(0, 7)) {
		const overlay = data[2].substr(7)
		const input = data[3]
		const state = data[4]

		const index = localState.overlays.findIndex(o => o.number === overlay)

		localState.overlays[index].input = '1' === state ? input : null
	} else if ('Input' === data[2]) {
		const input = data[3]
		const state = data[4]

		if ('1' === state)
			localState.active = input
		else if (input === localState.active)
			localState.active = null
	} else if ('InputPreview' === data[2]) {
		const input = data[3]
		const state = data[4]

		if ('1' === state)
			localState.preview = input
		else if (input === localState.active)
			localState.preview = null
	} else if ('InputPlaying' === data[2]) {
		const input = data[3]
		const state = data[4]

		const index = localState.inputs.findIndex(i => i.number === input)

		localState.inputs[index].state = '1' === state ? 'Running' : 'Paused'
	} else if ('InputAudio' === data[2]) {
		// ignoring for now
	} else {
		// If uncaught by any known handler
		log.push('state watcher', 'Unrecognized ACTS event. Refreshing state from XML.')
		refresh()

		return
	}

	// Update the store
	state.set(localState)
}

function refresh() {
	send('XML', 'state watcher')
}

function extractXml(xml) {
	const container = xml2js(xml, {compact: true})

	if (!container?.vmix)
		return null

	const data = container.vmix

	const vmix = {}

	vmix.version = data.version?._text
	vmix.edition = data.edition?._text
	vmix.inputs = data.inputs?.input?.map(i => ({
		...i._attributes,
		_text: i._text,
	})) ?? []
	vmix.overlays = data.overlays?.overlay?.map(o => ({
		...o._attributes,
		input: o._text ?? null,
	})) ?? []
	vmix.preview = data.preview?._text
	vmix.active = data.active?._text
	vmix.fadeToBlack = data.fadeToBlack?._text
	vmix.transitions = data.transitions?.transition?.map(t => t._attributes) ?? []
	vmix.recording = data.recording?._text
	vmix.external = data.external?._text
	vmix.streaming = data.streaming?._text
	vmix.playList = data.playList?._text
	vmix.multiCorder = data.multiCorder?._text
	vmix.fullscreen = data.fullscreen?._text
	vmix.audio = data.audio ?? {}
	vmix.audio.master = data.audio?.master?._attributes
	vmix.dynamic = data.dynamic

	return vmix
}

socket.on('ready', _ => {
	send('XML', 'state watcher')
	send('SUBSCRIBE ACTS', 'state watcher')
})

export default {state, time}
